import window from 'window-or-global';
import AtlassianEditor from '../bootstrap/atlassian-editor';

export const exportAjsRteAsGlobal = () => {
	if (typeof window.AJS.Rte === 'undefined') {
		window.AJS.Rte = { ...AtlassianEditor.Rte };
	}
	if (typeof window.AJS.Rte.getEditor === 'undefined') {
		window.AJS.Rte = { ...window.AJS.Rte, ...AtlassianEditor.Rte };
	}
};
